export const BASE_URL = 'https://frostbarkdigital.com';
export const SITE_NAME = 'Frostbark Digital';
export const LOGO_URL = '/logo.svg';
export const OG_IMAGE_SIZE = { width: 1200, height: 630 } as const;
export const TWITTER_HANDLE = '@frostbarkdig';
export const CONTACT_EMAIL = 'info@frostbarkdigital.com';

// The legal entity behind the Frostbark Digital brand. Named in the Terms so
// the agreement identifies an actual contracting party.
export const LEGAL_ENTITY = 'MGT Limited Inc.';
export const LEGAL_ENTITY_LINE = 'Frostbark Digital, a d/b/a of MGT Limited Inc.';

// Frostbark Digital launched 2024-08-30, and both legal documents were dated
// that day. Each page tracks its own revision date, because a "last updated"
// date is only meaningful if it moves when that document's text moves.
//
// Privacy policy text is unchanged since launch, so it keeps the launch date.
export const PRIVACY_LAST_UPDATED = '08 / 30 / 2024';

// Terms were revised on 2026-07-29 to name the contracting entity and to cover
// all fifteen service lines rather than seven.
export const TERMS_LAST_UPDATED = '29 / 07 / 2026';

export const SOCIAL_LINKS = [
  { name: 'LinkedIn', url: 'https://www.linkedin.com/company/frostbarkdigital' },
  { name: 'Instagram', url: 'https://www.instagram.com/frostbarkdigital' },
  { name: 'X / Twitter', url: 'https://x.com/frostbarkdig' },
  { name: 'TikTok', url: 'https://www.tiktok.com/@frostbarkdigital' },
  { name: 'Facebook', url: 'https://www.facebook.com/frostbarkdigital' }
];
